    import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is defined in your config/api.js
import { useParams, useNavigate } from 'react-router-dom';

const EditContraEntry = () => {
    const { id } = useParams(); // Get the contra entry ID from the URL
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        party_id: '',
        dr_in_amount: '',
        cr_in_amount: '',
    });
    const [message, setMessage] = useState('');

    // Fetch existing data when component loads
    useEffect(() => {
        fetch(`${BASE_URL}contraentry/${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    setFormData({
                        party_id: data.data.party_id,
                        dr_in_amount: data.data.dr_in_amount,
                        cr_in_amount: data.data.cr_in_amount,
                    });
                } else {
                    setMessage('Failed to fetch contra entry details.');
                }
            })
            .catch((error) => console.error('Error fetching contra entry:', error));
    }, [id]);

    // Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        fetch(`${BASE_URL}contraentry/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    setMessage(data.message);
                    setTimeout(() => navigate('/ContraEntriesList'), 2000); // Navigate back to the list after 2 seconds
                } else {
                    setMessage('Failed to update contra entry.');
                }
            })
            .catch((error) => console.error('Error updating contra entry:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <h3>Edit Contra Entry</h3>
            </div>

            <section className="section">
                <div className="card">
                    <div className="card-header">
                        <h4>Update Contra Entry</h4>
                    </div>
                    <div className="card-body">
                        {message && <div className="alert alert-info">{message}</div>}
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="party_id" className="form-label">
                                    Party ID
                                </label>
                                <input
                                    type="number"
                                    id="party_id"
                                    name="party_id"
                                    className="form-control"
                                    value={formData.party_id}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="dr_in_amount" className="form-label">
                                    Dr In Amount
                                </label>
                                <input
                                    type="number"
                                    id="dr_in_amount"
                                    name="dr_in_amount"
                                    className="form-control"
                                    value={formData.dr_in_amount}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="cr_in_amount" className="form-label">
                                    Cr In Amount
                                </label>
                                <input
                                    type="number"
                                    id="cr_in_amount"
                                    name="cr_in_amount"
                                    className="form-control"
                                    value={formData.cr_in_amount}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-primary">
                                Update
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary ms-2"
                                onClick={() => navigate('/ContraEntryList')}
                            >
                                Cancel
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditContraEntry;
